import { Grid2 } from "@mui/material";

import { FrmTextField } from "components/formFields/FrmTextField";

import { i18n } from "services/i18nService";
import { formatContact } from "services/utility/formatting";

export function LocationAddress(props) {
  const {
    value,
    handleInputFieldChange,
    addressType,
    disableContactEditing,
    dataIndex,
  } = props;

  function handleAddressChange(name, newValue) {
    const address = {
      ...value,
      address: { ...value.address, [name]: newValue },
    };
    handleInputFieldChange(addressType, address, dataIndex);
  }

  function handleContactChange(name, newValue) {
    const address = { ...value, [name]: newValue };
    handleInputFieldChange(addressType, address, dataIndex);
  }

  return (
    <Grid2 container direction="row" spacing={1}>
      <Grid2 size={6}>
        <FrmTextField
          name="company"
          label={i18n("global.Company")}
          maxLength={255}
          onValueBlur={handleContactChange}
          value={value?.company}
          disabled={disableContactEditing}
          autoComplete="new-password"
        />
        <FrmTextField
          name="contact"
          label={i18n("global.Contact")}
          maxLength={255}
          value={formatContact(value?.contact)}
          onValueBlur={handleContactChange}
          disabled={disableContactEditing}
          autoComplete="new-password"
        />
        <FrmTextField
          name="phone"
          label={i18n("global.Phone")}
          maxLength={255}
          value={value?.phone}
          onValueBlur={handleContactChange}
          disabled={disableContactEditing}
          autoComplete="new-password"
        />
        <FrmTextField
          name="email"
          label={i18n("global.Email")}
          maxLength={255}
          value={value?.email}
          onValueBlur={handleContactChange}
          disabled={disableContactEditing}
          autoComplete="new-password"
        />
      </Grid2>
      <Grid2 size={6}>
        {[1, 2, 3, 4, 5].map((i) => (
          <FrmTextField
            key={"line" + i}
            name={"line" + i}
            label={`Line ${i}`}
            maxLength={400}
            onValueBlur={handleAddressChange}
            value={value?.address ? value.address["line" + i] : ""}
            dataTesting={"line" + i}
            autoComplete="new-password"
          />
        ))}
        <Grid2 container direction="row" spacing={1}>
          <Grid2 size={6}>
            <FrmTextField
              name="city"
              label={i18n("global.City")}
              maxLength={255}
              onValueBlur={handleAddressChange}
              value={value?.address?.city}
              autoComplete="new-password"
            />
          </Grid2>
          <Grid2 size={6}>
            <FrmTextField
              name="stateProvince"
              label={i18n("global.State/Province")}
              maxLength={255}
              onValueBlur={handleAddressChange}
              value={value?.address?.stateProvince}
              autoComplete="new-password"
            />
          </Grid2>
          <Grid2 size={6}>
            <FrmTextField
              name="postalCode"
              label={i18n("frmLabel.PostalCode")}
              maxLength={30}
              onValueBlur={handleAddressChange}
              value={value?.address?.postalCode}
              autoComplete="new-password"
            />
          </Grid2>
          <Grid2 size={6}>
            <FrmTextField
              name="country"
              label={i18n("global.Country")}
              maxLength={255}
              onValueBlur={handleAddressChange}
              value={value?.address?.country}
              autoComplete="new-password"
            />
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
